@if (showField$ | async) {
  <mat-form-field>
    <mat-label>{{ field.label | translate }}</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate [formControl]="$any(field.control).controls['fromDate']" placeholder="From Date">
      <input matEndDate [formControl]="$any(field.control).controls['toDate']" placeholder="End date">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
    @if (hasDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </mat-form-field>
}
